import React ,{ useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { AgGridReact } from "@ag-grid-community/react";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { useDispatch, useSelector } from 'react-redux';
import 'ag-grid-community/styles/ag-theme-alpine.css'; 
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
const Instagram = () => {
const [activepage , setactivepage] = useState(1);

const handletogglepage = (num) =>
{
    setactivepage(num);
}
    const navigate = useNavigate();
    const newproductclick = () => {
        navigate('/admin/add-new-linkedin-post');
    };
    const newfbcampaginclick = () => {
        navigate('/admin/add-new-linkedin-campaign');
    };
    


      const rowData = [
        {
          campaignName: "Spring Sale",
          impressions: 12000,
          clicks: 1230,
          ctr: "10.2%",
          conversions: 150,
          spend: "$300",
        },
        {
          campaignName: "Product Launch",
          impressions: 9500,
          clicks: 860,
          ctr: "9.1%",
          conversions: 100,
          spend: "$250",
        }
      ];
    
      const columnDefs = [
        { headerName: 'Campaign Name', field: 'campaignName', sortable: true, filter: true, flex: 1 },
        { headerName: 'Impressions', field: 'impressions', sortable: true, filter: true, flex: 1 },
        { headerName: 'Clicks', field: 'clicks', sortable: true, filter: true, flex: 1 },
        { headerName: 'CTR', field: 'ctr', sortable: true, filter: true, flex: 1 },
        { headerName: 'Conversions', field: 'conversions', sortable: true, filter: true, flex: 1 },
        { headerName: 'Spend', field: 'spend', sortable: true, filter: true, flex: 1 },
        {
          headerName: 'Status',
          field: 'status',
          cellRenderer: (params) => (
            <input type="checkbox" checked={params.value} readOnly />
          ),
          flex: 1,
          filter: false
        },
        {
          headerName: 'Action',
          cellRenderer: () => (
            <FontAwesomeIcon icon={faPenToSquare} style={{ cursor: 'pointer', color: '#007bff' }} />
          ),
          flex: 1,
          filter: false,
        },
      ];
    return (
        <div className="">
            <div className="dashboardbox" style={{ width: "100%" }}>
                {/* <div className="productstogglebar mt-2">
              <div
                className="filterdiv couponfilterdiv"
                onClick={newproductclick}
              >
                <FontAwesomeIcon
                  icon={faPlus}
                  className="iconstyles"
                  style={{ color: "#64748B" }}
                />
                <p>Add Post</p>
              </div>
          </div> */}
                <div className="productstogglebar mt-2">
                <div className={activepage == 1 ? "filterdiv couponfilterdiv questiondiv active" : "filterdiv couponfilterdiv questiondiv"}  onClick={() => {handletogglepage(1)}} >
                        <p>Post</p>
                    </div>

                    <div className={activepage == 2 ? "filterdiv couponfilterdiv questiondiv active" : "filterdiv couponfilterdiv questiondiv"}  onClick={() => {handletogglepage(2)}} >
              
                        <p>Campaign</p>
                    </div>





              {
                activepage == 1 ?

                <div className="filterdiv couponfilterdiv  adddiv" onClick={newproductclick}>
                <FontAwesomeIcon
               icon={faPlus}
               className="iconstyles"
               style={{ color: "#64748B" }}
          />
          <p>Add Post</p>
        </div> : 
        
        <div className="filterdiv couponfilterdiv  adddiv" onClick={newfbcampaginclick}>
        <FontAwesomeIcon
       icon={faPlus}
       className="iconstyles"
       style={{ color: "#64748B" }}
  />
  <p>Add Campaign</p>
</div>
              }
                </div>
                <div
                    className={"ag-theme-quartz mt-4"}
                    style={{ width: "100%", height: 550 }}
                >
                <div className="ag-theme-alpine" style={{ height: 300, width: '100%' }}>
                      <AgGridReact
                        rowData={rowData}
                        columnDefs={columnDefs}
                        pagination={false}
                        domLayout="autoHeight"
                      />
                    </div>
                </div>
            </div>
        </div>
    )
};
export default Instagram